// extracted by mini-css-extract-plugin
export default {"chooseTemplateErrorToast":"cb8e94007f0f","errorToastLink":"a955d8149e56"};